<template>

<core-dropdown class="input" trigger="manual" v-on:forceClose="is.expanded = false" :expanded="is.expanded" v-click-outside="onOutsideClick">

	<core-button v-on:click.native="onToggleClick" tooltip="Change count" theme="filter" icon="caret-down" class="input-button"><span v-if="!window.is.mobile && value !== 'all'"></span><b>{{ text }}</b></core-button>
	
	<core-dropdown-list align="right" theme="filter" :caret="true">

		<core-simplebar class="input-options-scroll">

			<core-dropdown-link v-for="item in options" v-bind:key="item.key" v-on:click.native="onOptionClick(item.key)" v-bind:class="{'is-active': value === item.key}">

				{{ item.text }}

			</core-dropdown-link>

		</core-simplebar>

	</core-dropdown-list>

</core-dropdown>

</template>

<script>

import vClickOutside from 'v-click-outside'

export default {

	components: {
		
	},

	directives: {
		clickOutside: vClickOutside.directive
	},

	props: [
		'page',
		'filter'
	],
	
	data: function() {

		return {
			is: {
				expanded: false
			}
		}

	},

	computed: {

		options: function() {

			var options = []

			options.push({
				key: 0,
				text: (this.window.is.mobile) ? 'Any' : 'Any count'
			})

			options.push({
				key: 2,
				text: (this.window.is.mobile) ? '2p' : '2 players'
			})

			options.push({
				key: 3,
				text: (this.window.is.mobile) ? '3p' : '3 players'
			})

			options.push({
				key: 4,
				text: (this.window.is.mobile) ? '4p' : '4 players'
			})

			options.push({
				key: 5,
				text: (this.window.is.mobile) ? '5p' : '5 players'
			})

			options.push({
				key: 6,
				text: (this.window.is.mobile) ? '6p+' : '6+ players'
			})

			return options

		},

		value: function() {

			return this.$store.getters['filter/insights/' + this.filter + '/players']

		},

		text: function() {

			return this.options[(this.value) ? this.value - 1 : this.value].text

		}

	},

	methods: {

		onToggleClick: function() {

			this.is.expanded = !this.is.expanded

		},

		onOutsideClick: function() {

			this.is.expanded = false

		},

		onOptionClick: function(value) {

			this.$store.commit('filter/insights/' + this.filter + '/players', value)

		}

	}

}

</script>

<style scoped>

.is-smaller .input-options-scroll,
.is-desktop .input-options-scroll {
	min-width: 120px;
	width: 100%;
	max-height: 290px;
}

</style>
